import { NotificationAction, NotificationsActionType } from './notificationsActionType';
import { INotificationsState } from './notificationsState';
import { INotification } from './notification.interface';
import { NotificationType } from './notificationType.enum';

export function notificationsReducer(
    state: INotificationsState = {
        blockUI: false,
        notifications: [],
        redirecting: false,
    },
    action: NotificationAction,
) {
    const { notifications, redirecting } = state;
    let newNotifications: INotification[] = [...notifications];
    let payload: any;

    switch (action.type) {
        case NotificationsActionType.ADD_NOTIFICATION:
            payload = action.payload;
            if (!redirecting) {
                if (
                    newNotifications.findIndex(
                        (notification) => notification.id === payload.notification.id,
                    ) === -1
                ) {
                    newNotifications.push(payload.notification);
                }
            }
            return {
                blockUI: checkBlockUI(newNotifications),
                notifications: newNotifications,
                redirecting: checkRedirecting(newNotifications),
            };

        case NotificationsActionType.REMOVE_NOTIFICATION:
            payload = action.payload;
            newNotifications = newNotifications.filter((notification) => {
                return notification.id !== payload.notificationId;
            });
            return {
                blockUI: checkBlockUI(newNotifications),
                notifications: newNotifications,
                redirecting: checkRedirecting(newNotifications),
            };

        case NotificationsActionType.UPDATE_NOTIFICATION_MESSAGE:
            payload = action.payload;
            newNotifications.forEach((notification) => {
                if (notification.id === payload.notificationId) {
                    notification.message = payload.notificationMessage;
                }
            });
            return {
                blockUI: state.blockUI,
                notifications: newNotifications,
                redirecting: state.redirecting,
            };

        default:
            return state;
    }
}

function checkBlockUI(notifications: INotification[]): boolean {
    return notifications.reduce<boolean>(
        (blockUINotificationPresent, notification) =>
            blockUINotificationPresent || notification.blockUI,
        false,
    );
}

function checkRedirecting(notifications: INotification[]): boolean {
    return notifications.reduce<boolean>(
        (redirectingNotificationPresent, notification) =>
            redirectingNotificationPresent || notification.type === NotificationType.Redirecting,
        false,
    );
}
